module.exports = __webpack_public_path__ + "img/19.916e88fb.jpg";